import React, { Component } from 'react';
import commonUtil from '../../../../../utils/commonUtil';
import ReactWebShare from '../../../../../components/ReactWebShare';

const channel = commonUtil.getChannel();

const sharelinksData = {
  text: "",
  url: '',
  title: "",
}

class DocumentsPDF extends Component {
  render() {
    return (
      <div className="invitedListIcons searchResult share-download-icons" style={{float : this.props.isWap ? "right" : ''}}>
        
       {<img src={commonUtil.getAssetURL() + '/images/file_download.svg'} alt="file_download" className="icon_download_file" onClick={() => this.props.handlePDFDownload()} style={{width:'24px',height:"24px"}}/> }
        {channel == 'wap' ? <ReactWebShare data={sharelinksData} />
          :
          <img src={commonUtil.getAssetURL() + '/images/Ios_share.svg'} alt="ios_share" className="icon_share_ios" onClick={() => this.props.handlerSharelink()} style={{ width: '24px', height: "24px" }} />
        }
        {/* <i className="icon-descarga" onClick={() => this.props.handlePDFDownload()} aria-hidden="true" /> */}
        {/* <i className="icon-compartir" onClick={() => this.props.handlerSharelink()} aria-hidden="true" /> */}
        {/* <i className="icon-imprimir" onClick={() => this.props.handlePrint()} aria-hidden="true" /> */}
      </div>
    );
  }
}

export default DocumentsPDF;
